import { render, staticRenderFns } from "./Credential.vue?vue&type=template&id=ca1ffb62&scoped=true&"
import script from "./Credential.vue?vue&type=script&lang=js&"
export * from "./Credential.vue?vue&type=script&lang=js&"
import style0 from "./Credential.vue?vue&type=style&index=0&id=ca1ffb62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1ffb62",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CBox: require('@chakra-ui/vue').CBox})
